/* eslint-disable react-refresh/only-export-components -- shared settings UI helpers */

export function passwordStrength(pw) {
  if (!pw) return { score: 0, label: "", color: "" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  if (score <= 1) return { score, label: "Very weak", color: "bg-rose-500" };
  if (score === 2) return { score, label: "Weak", color: "bg-orange-400" };
  if (score === 3) return { score, label: "Fair", color: "bg-amber-400" };
  if (score === 4) return { score, label: "Strong", color: "bg-emerald-500" };
  return { score, label: "Very strong", color: "bg-emerald-600" };
}

export function Banner({ type, text, onDismiss }) {
  if (!text) return null;
  const ok = type === "ok";
  return (
    <div
      className={`flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium ${
        ok
          ? "bg-emerald-50 text-emerald-900 ring-1 ring-emerald-200/70"
          : "bg-rose-50 text-rose-900 ring-1 ring-rose-200/70"
      }`}
      role="status"
    >
      <i className={`text-base ${ok ? "ri-checkbox-circle-line text-emerald-600" : "ri-error-warning-line text-rose-500"}`} aria-hidden />
      <span className="flex-1">{text}</span>
      {onDismiss && (
        <button type="button" onClick={onDismiss} className="ml-auto opacity-60 hover:opacity-100">
          <i className="ri-close-line" aria-hidden />
        </button>
      )}
    </div>
  );
}

export function SectionHeading({ label, desc }) {
  return (
    <div className="mb-5">
      <h4 className="text-base font-semibold tracking-tight text-slate-900 dark:text-slate-100">{label}</h4>
      {desc && <p className="mt-1 text-xs leading-relaxed text-slate-500">{desc}</p>}
    </div>
  );
}
